import React from 'react';
import { useParams } from 'react-router-dom';
import { GroundTruthAudit } from './GroundTruthAudit';

export const GroundTruthAuditPage: React.FC = () => {
  const { gtSampleId } = useParams<{ gtSampleId: string }>();

  return <GroundTruthAudit key={gtSampleId} gtSampleId={gtSampleId ?? null} />;
};
